// extracted by mini-css-extract-plugin
export default {"authButton":"auth_authButton__h3hKg","ninetyDegrees":"auth_ninetyDegrees__AEy8E"};